<emm-management-layout>
    <emm-progress-bar [isLoading$]="centerLoading$" progress-bar-center></emm-progress-bar>
    <emm-search-filter
        [addDialog]="false"
        [attr.data-testid]="'location_set_types_search_bar'"
        [displaySearchWithOptions]="true"
        [fields]="fields$ | async"
        [isAdminOrAuthor]="this.isAdmin || this.isAuthor"
        [isSuperAdmin]="this.isSuperAdmin"
        [filteredOptions]="filteredOptions$"
        layout-center-header
        [searchLabel]="'Type location name or number'"
        (filter)="onFilter($event)"
        (selected)="onSelectingLocation($event)"
    ></emm-search-filter>
    <header
        *ngIf="storeNumber && nodes !== null"
        class="effective-date"
        layout-center-content
    >
        <label>Effective Date</label>
        <input readonly [(ngModel)]="readOnlyEffectiveDate" />
    </header>
    <tree-root
        *ngIf="storeNumber && (nodes$ | async) !== null"
        class="node-tree"
        layout-center-content
        [nodes]="nodes$ | async"
        [options]="options"
    ></tree-root>
    <main
        *ngIf="storeNumber && nodes === null"
        layout-center-content
    >
        <h3>There are no menu selections available for store: {{ storeNumber }}</h3>
    </main>


    <main class="row overrides" layout-right-content>
        <div class="col" *ngIf="menuOptions">
            <div  class="flex-space-between-center flex-row-wrap" >
                <label  style="padding-top: 20px;" class="flex-40">Effective Date</label>
                <emm-effective-date-selection 
                                              source="management"
                                              [label]="'Effective Date'"
                                              (effectiveDateChange)="selectEffectiveDate($event)" class="flex-60">
                </emm-effective-date-selection>
            </div>
            <div class="line-separator"></div>
            <form [formGroup]="selectionsFormGroup">
                <mat-vertical-stepper formArrayName="categories" #optionStepper>
                    <ng-container *ngFor="let category of categories?.controls; let i=index">
                        <mat-step [formGroupName]="i" [stepControl]="categories?.controls[i]">
                            <ng-template matStepLabel class="categories-step-header">
                                Select {{ category.value.title }} Option
                                <br>
                                <span class="font-weight-bold cfaPrimaryColor" *ngIf="category.value.selectedValue != undefined">
                                    {{ category.value.selectedValue.name }}
                                </span>
                            </ng-template>
                            <mat-radio-group formControlName="selectedValue">
                                <mat-radio-button [value]="option" *ngFor="let option of category?.value.options; let j=index"
                                                  class="icon-radio-button mr-md-2 mb-2" color="primary" [checked]="option && category.value.selectedValue && (option?.tag == category?.value?.selectedValue?.tag)">
                                    <div class="menu-selection-tile-title">
                                        {{ option.name }}
                                    </div>
                                    <div class="menu-selection-tile-list-container">
                                        <div *ngFor="let option of option.items" class="menu-selection-tile-list">
                                            <p [innerHTML]="(option.name.length > 25)? (option.name | slice:0:35)+'..':(option.name)"></p>
                                        </div>
                                    </div>
                                </mat-radio-button>
                            </mat-radio-group>
                            <div>
                                <button mat-button matStepperPrevious color="primary" type="button" *ngIf="i > 0">Back</button>
                                <button mat-button matStepperNext color="primary" type="button" *ngIf="i < categories?.controls.length - 1">Next</button>
                                <button mat-button matStepperSave color="primary" type="button" *ngIf="i === categories?.controls.length - 1" (click)="onSave()">Save</button>
                            </div>
                        </mat-step>
                    </ng-container>
                </mat-vertical-stepper>
            </form>
        </div>
        <div class="col" *ngIf="storeNumber && !menuOptions">
            <h4>There are no menu options available for store: {{ storeNumber }}</h4>
        </div>
    </main>
</emm-management-layout>
